import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, useEffect, useCallback, useMemo, useLayoutEffect, useRef } from "react";
import ReactDOM, { render, createPortal } from "react-dom";
import { useTheme } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Rnd } from "react-rnd";
var RenderInWindow = function(props) {
    var _useState = _sliced_to_array(useState(null), 2), container = _useState[0], setContainer = _useState[1];
    var newWindow = useRef(null);
    useEffect(function() {
        setContainer(document.createElement("div"));
    }, []);
    var close = function() {
        setContainer(null);
        props.setModal(function(prev) {
            return _object_spread_props(_object_spread({}, prev), {
                mode: "normal",
                open: false
            });
        });
    };
    useEffect(function() {
        if (container) {
            newWindow.current = window.open("", "", "width=600,height=400,left=200,top=200");
            container.classList.add("p-4");
            newWindow.current.document.body.appendChild(container);
            newWindow.current.document.head.innerHTML = window.document.head.innerHTML;
            var curWindow = newWindow.current;
            curWindow.addEventListener("beforeunload", close);
            return function() {
                curWindow.close();
                curWindow.removeEventListener("beforeunload", close);
            };
        }
    }, [
        container
    ]);
    return container && /*#__PURE__*/ createPortal(props.child, container);
};
export function ModalAllder(_param) {
    var modal = _param.modal, setModal = _param.setModal, hbtn = _param.hbtn, htitle = _param.htitle, children = _param.children, props = _object_without_properties(_param, [
        "modal",
        "setModal",
        "hbtn",
        "htitle",
        "children"
    ]);
    var theme = useTheme();
    var isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    var _useWindowSize = _sliced_to_array(useWindowSize(), 2), WindowWidth = _useWindowSize[0], WindowHeight = _useWindowSize[1];
    var _useState = _sliced_to_array(useState(null), 2), prevModal = _useState[0], setPrevModal = _useState[1];
    var _useState1 = _sliced_to_array(useState(false), 2), windowpopShow = _useState1[0], setWindowpopShow = _useState1[1];
    // console.log(modal)
    var getCenterModal = function() {
        setModal(function(prev) {
            return _object_spread_props(_object_spread({}, prev), {
                x: "".concat((WindowWidth - modal.width) / 2),
                y: "".concat((WindowHeight - modal.height) / 2)
            });
        });
    };
    useEffect(function() {
        var cpin = localStorage.getItem("".concat(modal.modalname));
        if (cpin) {
            setModal(JSON.parse(cpin));
        } else {
            getCenterModal();
        }
    }, [
        WindowWidth,
        WindowHeight
    ]);
    useEffect(function() {
        if (modal.pin) {
            localStorage.setItem("".concat(modal.modalname), JSON.stringify(modal));
        }
    }, [
        modal
    ]);
    var setFitscreen = function() {
        setPrevModal(modal);
        setModal(function(prev) {
            return _object_spread_props(_object_spread({}, prev), {
                width: WindowWidth,
                height: WindowHeight,
                mode: "fit",
                x: 0,
                y: 0
            });
        });
    };
    var setPin = function() {
        if (!modal.pin) {
            setModal(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    pin: true
                });
            });
            modal.pin = true;
            localStorage.setItem("".concat(modal.modalname), JSON.stringify(modal));
        } else {
            setModal(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    pin: false
                });
            });
            localStorage.removeItem("".concat(modal.modalname));
        }
    };
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: modal.mode == "popup" ? /*#__PURE__*/ _jsx(RenderInWindow, {
            child: children,
            setModal: setModal,
            setWindowpopShow: setWindowpopShow
        }) : /*#__PURE__*/ _jsx("div", {
            className: "tg-bp3-dialog-resizable-draggable",
            style: {
                top: 0,
                left: 0,
                position: "fixed",
                zIndex: 1100
            },
            children: /*#__PURE__*/ _jsxs(Rnd, {
                style: {
                    border: "solid 1px #ddd",
                    background: "#FFF",
                    zIndex: modal.open ? 1100 : "hidden",
                    borderRadius: "10px",
                    overflow: "hidden",
                    visibility: "".concat(modal.open ? "visible" : "hidden"),
                    position: "fixed",
                    transform: "rotate(30deg)"
                },
                size: {
                    width: modal.open ? modal.width : 0,
                    height: modal.open ? modal.height : 0
                },
                position: {
                    x: modal.x,
                    y: modal.y
                },
                onResizeStop: function(e, d, ref, delta, position) {
                    setModal(function(prev) {
                        return _object_spread_props(_object_spread({}, prev), {
                            width: "".concat(ref.style.width),
                            height: "".concat(ref.style.height),
                            x: position.x,
                            y: position.y
                        });
                    });
                },
                onDragStop: function(e, d) {
                    setModal(function(prev) {
                        return _object_spread_props(_object_spread({}, prev), {
                            x: d.x,
                            y: d.y
                        });
                    });
                },
                maxHeight: WindowHeight,
                maxWidth: WindowWidth - 20,
                dragHandleClassName: "dragHandle",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: " d-flex align-items-center dragHandle ".concat(!isMobile ? "pagezoom" : ""),
                        style: {
                            backgroundColor: "rgb(176, 4, 18)",
                            height: "45px",
                            borderTopLeftRadius: "10px",
                            borderTopRightRadius: "10px",
                            padding: "10px",
                            cursor: "move"
                        },
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "text-white fs-18 me-auto pt-1",
                                children: [
                                    " ",
                                    htitle
                                ]
                            }),
                            hbtn ? /*#__PURE__*/ _jsxs(_Fragment, {
                                children: [
                                    /*#__PURE__*/ _jsx("button", {
                                        type: "button",
                                        className: "btn btn-modal-export mx-2",
                                        onClick: function() {
                                            setModal(function(prev) {
                                                return _object_spread_props(_object_spread({}, prev), {
                                                    mode: "popup"
                                                });
                                            });
                                        }
                                    }),
                                    /*#__PURE__*/ _jsx("button", {
                                        type: "button",
                                        className: "btn btn-modal-pin mx-2  ".concat(modal.pin ? "active" : ""),
                                        onClick: function() {
                                            setPin();
                                        }
                                    }),
                                    /*#__PURE__*/ _jsx("button", {
                                        type: "button",
                                        className: "btn btn-modal-window mx-2",
                                        onClick: function() {
                                            modal.mode == "normal" ? setFitscreen() : setModal(function(prev) {
                                                return _object_spread_props(_object_spread({}, prev), {
                                                    width: prevModal.width,
                                                    height: prevModal.height,
                                                    mode: "normal",
                                                    x: prevModal.x,
                                                    y: prevModal.y
                                                });
                                            });
                                        }
                                    })
                                ]
                            }) : "",
                            /*#__PURE__*/ _jsx("button", {
                                type: "button",
                                className: "btn btn-modal-close",
                                onClick: function() {
                                    return setModal(function(prev) {
                                        return _object_spread_props(_object_spread({}, prev), {
                                            open: false
                                        });
                                    });
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        style: {
                            height: modal.open ? parseFloat(modal.height) - 20 : 0,
                            overflowY: "auto"
                        },
                        children: /*#__PURE__*/ _jsx("div", {
                            className: isMobile ? "p-4" : "p-4 pagezoom",
                            children: children
                        })
                    })
                ]
            })
        })
    });
}
function useWindowSize() {
    var _useState = _sliced_to_array(useState([
        0,
        0
    ]), 2), size = _useState[0], setSize = _useState[1];
    useLayoutEffect(function() {
        var updateSize = function updateSize() {
            setSize([
                window.innerWidth,
                window.innerHeight
            ]);
        };
        window.addEventListener("resize", updateSize);
        updateSize();
        return function() {
            return window.removeEventListener("resize", updateSize);
        };
    }, []);
    return size;
}
var NewWindow = function(param) {
    var children = param.children, close = param.close;
    var newWindow = useMemo(function() {
        return window.open("about:blank", "newWin", "width=400,height=300,left=".concat(window.screen.availWidth / 2 - 200, ",top=").concat(window.screen.availHeight / 2 - 150));
    });
    newWindow.onbeforeunload = function() {
        close();
    };
    useEffect(function() {
        return function() {
            return newWindow.close();
        };
    });
    return /*#__PURE__*/ createPortal(children, newWindow.document.body);
};
